"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dummyLogger = void 0;
exports.dummyLogger = {
    trace: () => void 0,
    debug: () => void 0,
    info: () => void 0,
    warn: () => void 0,
    error: () => void 0,
    setLevel: () => void 0,
    getLogger: () => exports.dummyLogger,
    getLoggers: () => void 0,
    getLevel: () => void 0,
    setDefaultLevel: () => void 0,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZHVtbXktbG9nZ2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xvZ2dlci91dGlsL2R1bW15LWxvZ2dlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLFdBQVcsR0FBRztJQUN2QixLQUFLLEVBQUUsR0FBRyxFQUFFLENBQUMsS0FBSyxDQUFDO0lBQ25CLEtBQUssRUFBRSxHQUFHLEVBQUUsQ0FBQyxLQUFLLENBQUM7SUFDbkIsSUFBSSxFQUFFLEdBQUcsRUFBRSxDQUFDLEtBQUssQ0FBQztJQUNsQixJQUFJLEVBQUUsR0FBRyxFQUFFLENBQUMsS0FBSyxDQUFDO0lBQ2xCLEtBQUssRUFBRSxHQUFHLEVBQUUsQ0FBQyxLQUFLLENBQUM7SUFDbkIsUUFBUSxFQUFFLEdBQUcsRUFBRSxDQUFDLEtBQUssQ0FBQztJQUN0QixTQUFTLEVBQUUsR0FBRyxFQUFFLENBQUMsbUJBQVc7SUFDNUIsVUFBVSxFQUFFLEdBQUcsRUFBRSxDQUFDLEtBQUssQ0FBQztJQUN4QixRQUFRLEVBQUUsR0FBRyxFQUFFLENBQUMsS0FBSyxDQUFDO0lBQ3RCLGVBQWUsRUFBRSxHQUFHLEVBQUUsQ0FBQyxLQUFLLENBQUM7Q0FDUCxDQUFDIn0=